module.exports = __webpack_public_path__ + "static/img/materialLibrarylogo.b82d8fde.png";